function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _superPropGet(t, o, e, r) { var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e); return 2 & r && "function" == typeof p ? function (t) { return p.apply(e, t); } : p; }
function _get() { return _get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) { var p = _superPropBase(e, t); if (p) { var n = Object.getOwnPropertyDescriptor(p, t); return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value; } }, _get.apply(null, arguments); }
function _superPropBase(t, o) { for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf(t));); return t; }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
import { VectorLayerHandler } from './WfsVectorLayerPlugin/impl/VectorLayerHandler.ol';
import { MvtLayerHandler } from './WfsVectorLayerPlugin/impl/MvtLayerHandler.ol';
import { ReqEventHandler } from './WfsVectorLayerPlugin/ReqEventHandler';
import { DEFAULT_STYLES, styleGenerator } from './WfsVectorLayerPlugin/util/style';
import { LAYER_ID, LAYER_HOVER, LAYER_TYPE, RENDER_MODE_MVT, RENDER_MODE_VECTOR } from 'oskari-frontend/bundles/mapping/mapmodule/domain/constants';
var AbstractVectorLayerPlugin = Oskari.clazz.get('Oskari.mapping.mapmodule.AbstractVectorLayerPlugin');
var LayerComposingModel = Oskari.clazz.get('Oskari.mapframework.domain.LayerComposingModel');
var WFSLayerService = Oskari.clazz.get('Oskari.mapframework.bundle.mapwfs2.service.WFSLayerService');
var WfsLayerModelBuilder = Oskari.clazz.get('Oskari.mapframework.bundle.mapwfs2.domain.WfsLayerModelBuilder');
export var WfsVectorLayerPlugin = /*#__PURE__*/function (_AbstractVectorLayerP) {
  function WfsVectorLayerPlugin(config) {
    var _this;
    _classCallCheck(this, WfsVectorLayerPlugin);
    _this = _callSuper(this, WfsVectorLayerPlugin, [config]);
    _this._config = config;
    _this.__name = 'WfsVectorLayerPlugin';
    _this._clazz = 'Oskari.wfs.WfsVectorLayerPlugin';
    _this.renderMode = config.renderMode || RENDER_MODE_VECTOR;
    _this.oskariStyleSupport = true;
    _this.layertype = 'wfs';
    _this.layertypes = new Set([_this.layertype]);
    _this.vectorLayerHandler = new VectorLayerHandler(_this);
    _this.mvtLayerHandler = new MvtLayerHandler(_this);
    _this.layerHandlersByLayerId = {};
    return _this;
  }

  /* ---- AbstractMapModulePlugin functions ---- */
  _inherits(WfsVectorLayerPlugin, _AbstractVectorLayerP);
  return _createClass(WfsVectorLayerPlugin, [{
    key: "getLayerTypeSelector",
    value: function getLayerTypeSelector() {
      return 'wfslayer';
    }

    /**
     * Registers layer type to be handled by this layer plugin.
     *
     * @param {String} layertype for ex. "MYPLACES"
     * @param {String} modelClass layer model class name
     * @param {Object} modelBuilder layer model builder instance
     * @param {Object} eventHandlers
     */
  }, {
    key: "registerLayerType",
    value: function registerLayerType(layertype, modelClass, modelBuilder, eventHandlers) {
      if (this.layertypes.has(layertype) || !this.mapLayerService || !this.vectorFeatureService) {
        return;
      }
      this.layertypes.add(layertype);
      this.getMapModule().setLayerPlugin(layertype, this);
      this.getMapModule().registerDefaultFeatureStyle(layertype, DEFAULT_STYLES.style);
      this.vectorFeatureService.registerLayerType(layertype, this);
      this.vectorFeatureService.registerDefaultStyles(layertype, DEFAULT_STYLES);
      this.mapLayerService.registerLayerModel(layertype, modelClass);
      if (modelBuilder) {
        this.mapLayerService.registerLayerModelBuilder(layertype, modelBuilder);
      }
      this._registerEventHandlers(eventHandlers);
    }
  }, {
    key: "_registerEventHandlers",
    value: function _registerEventHandlers(eventHandlers) {
      var _this2 = this;
      if (!eventHandlers) {
        return;
      }
      Object.keys(eventHandlers).forEach(function (eventName) {
        if (typeof _this2._eventHandlers[eventName] !== 'undefined') {
          _this2._log.warn('Wfs plugin tried to register multiple handlers for event: ' + eventName);
          return;
        }
        _this2._eventHandlers[eventName] = eventHandlers[eventName];
        _this2.getSandbox().registerForEventByName(_this2, eventName);
      });
    }
  }, {
    key: "_initImpl",
    value: function _initImpl() {
      _superPropGet(WfsVectorLayerPlugin, "_initImpl", this, 3)([]);
      var sandbox = this.getSandbox();
      if (this.getMapModule().getSupports3D() && this.renderMode !== RENDER_MODE_VECTOR) {
        // 3D mapmodule doesn't support MVT
        this._log.warn('Changing WFS render mode (3d only supports GeoJSON). Configuration was for: ' + this.renderMode);
        this.renderMode = RENDER_MODE_VECTOR;
      }
      this.reqEventHandler = new ReqEventHandler(sandbox);
      this.WFSLayerService = new WFSLayerService(sandbox);
      this.vectorFeatureService = sandbox.getService('Oskari.mapframework.service.VectorFeatureService');
      this.mapLayerService = sandbox.getService('Oskari.mapframework.service.MapLayerService');
      if (!this.mapLayerService || !this.vectorFeatureService) {
        return;
      }
      var composingModel = new LayerComposingModel([LayerComposingModel.CAPABILITIES, LayerComposingModel.CLUSTERING_DISTANCE, LayerComposingModel.CREDENTIALS, LayerComposingModel.HOVER, LayerComposingModel.SRS, LayerComposingModel.VECTOR_STYLES, LayerComposingModel.URL, LayerComposingModel.VERSION, LayerComposingModel.WFS_LAYER], ['1.1.0', '2.0.0', '3.0.0']);
      var layerClass = 'Oskari.mapframework.bundle.mapwfs2.domain.WFSLayer';
      this.mapLayerService.registerLayerModel(this.getLayerTypeSelector(), layerClass, composingModel);
      this.mapLayerService.registerLayerModelBuilder(this.getLayerTypeSelector(), new WfsLayerModelBuilder(sandbox));
      this.vectorFeatureService.registerLayerType(this.layertype, this);
      this.vectorFeatureService.registerDefaultStyles(this.layertype, DEFAULT_STYLES);
      this.getMapModule().registerDefaultFeatureStyle(this.layertype, DEFAULT_STYLES.style);
      sandbox.registerService(this.WFSLayerService);
    }
  }, {
    key: "_createPluginEventHandlers",
    value: function _createPluginEventHandlers() {
      var vectorHandlers = this.vectorLayerHandler.createEventHandlers(this);
      var mvtHandlers = this.mvtLayerHandler.createEventHandlers(this);
      var commonHandlers = this.reqEventHandler.createEventHandlers(this);
      var eventKeys = _toConsumableArray(new Set([].concat(_toConsumableArray(Object.keys(vectorHandlers)), _toConsumableArray(Object.keys(mvtHandlers)), _toConsumableArray(Object.keys(commonHandlers)))));
      var handlers = {};
      // Call event handlers in all modules
      eventKeys.forEach(function (eventName) {
        handlers[eventName] = function (event) {
          [vectorHandlers, mvtHandlers, commonHandlers].forEach(function (handlerModule) {
            if (handlerModule.hasOwnProperty(eventName)) {
              handlerModule[eventName](event);
            }
          });
        };
      });
      return handlers;
    }
  }, {
    key: "_createRequestHandlers",
    value: function _createRequestHandlers() {
      return this.reqEventHandler.createRequestHandlers();
    }
  }, {
    key: "isLayerSupported",
    value: function isLayerSupported(layer) {
      if (!layer) {
        return false;
      }
      if (layer.isLayerOfType(this.getLayerTypeSelector())) {
        return true;
      }
      return this.layertypes.has(layer.getLayerType());
    }
  }, {
    key: "getRenderMode",
    value: function getRenderMode(layer) {
      var renderMode = this.renderMode;
      if (layer.getOptions()) {
        renderMode = layer.getOptions().renderMode || renderMode;
      }
      return renderMode;
    }
  }, {
    key: "isRenderModeSupported",
    value: function isRenderModeSupported(mode) {
      return mode === RENDER_MODE_MVT || mode === RENDER_MODE_VECTOR;
    }

    /**
     * @method updateLayerParams
     * Force updating features on layer
     */
  }, {
    key: "updateLayerParams",
    value: function updateLayerParams(layer, forced, params) {
      var handler = this._getLayerHandler(layer);
      if (handler) {
        handler.refreshLayer(layer);
      }
    }
  }, {
    key: "getLayerFeaturePropertiesInViewport",
    value: function getLayerFeaturePropertiesInViewport(layerId) {
      var result = this.getFeatures(null, {
        layers: [layerId]
      });
      var _result$layerId$featu = result[layerId].features,
        features = _result$layerId$featu === void 0 ? [] : _result$layerId$featu;
      return features.map(function (f) {
        return f.properties;
      });
    }

    /**
     * Override in actual plugins to returns features.
     *
     * Returns features that are currently on map filtered by given geometry and/or properties
     * {
     *   "[layer id]": {
     *      accuracy: 'extent',
     *      runtime: true,
     *      features: [{ geometry: {...}, properties: {...}}, ...]
     *   },
     *   ...
     * }
     * Runtime flag is true for features pushed with AddFeaturesToMapRequest etc and false/missing for features from WFS/OGC API sources.
     * For features that are queried from MVT-tiles we might not be able to get the whole geometry and since it's not accurate they will
     *  only get the extent of the feature. This is marked with accuracy: 'extent' and it might not even be the whole extent if the
     *  feature continues on unloaded tiles.
     * @param {Object} geojson an object with geometry and/or properties as filter for features. Geometry defaults to current viewport.
     * @param {Object} opts additional options to narrow feature collection
     * @returns {Object} an object with layer ids as keys with an object value with key "features" for the features on that layer and optional runtime-flag
     */
  }, {
    key: "getFeatures",
    value: function getFeatures() {
      var _this3 = this;
      var geojson = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var layers = opts.layers;
      if (!layers || !layers.length) {
        layers = this.getSandbox().getMap().getLayers().map(function (l) {
          return l.getId();
        });
      }
      var result = {};
      layers.forEach(function (layerId) {
        var layer = _this3.getSandbox().getMap().getSelectedLayer(layerId);
        if (!_this3.isLayerSupported(layer)) {
          return;
        }
        var err = _this3.detectErrorOnFeatureQuery(layer);
        if (err) {
          result[layerId] = {
            error: err,
            features: []
          };
          return;
        }
        var handler = _this3._getLayerHandler(layerId);
        if (!handler) {
          return;
        }
        var features = handler.getFeaturesWithFilter(layerId, geojson);
        if (features) {
          result[layerId] = {
            features: features
          };
        }
      });
      return result;
    }
    /**
     * @method addMapLayerToMap Adds wfs layer to map
     * @param {Oskari.mapframework.bundle.mapwfs2.domain.WFSLayer} layer
     * @param {Boolean} keepLayerOnTop
     * @param {Boolean} isBaseMap
     */
  }, {
    key: "addMapLayerToMap",
    value: function addMapLayerToMap(layer, keepLayerOnTop, isBaseMap) {
      var _this4 = this;
      var renderMode = this.getRenderMode(layer);
      if (!this.isRenderModeSupported(renderMode)) {
        return;
      }
      var handler = renderMode === RENDER_MODE_MVT ? this.mvtLayerHandler : this.vectorLayerHandler;
      this.layerHandlersByLayerId[layer.getId()] = handler;
      var added = handler.addMapLayerToMap(layer, keepLayerOnTop, isBaseMap);
      // Set oskari properties for vector feature service functionalities.
      added.forEach(function (lyr) {
        handler.applyZoomBounds(layer, lyr);
        var silent = true;
        lyr.set(LAYER_ID, layer.getId(), silent);
        lyr.set(LAYER_TYPE, layer.getLayerType(), silent);
        // don't add style for hover layer
        if (layer.isVisible() && !lyr.get(LAYER_HOVER)) {
          // Only set style if visible as it's an expensive operation
          // assumes style will be set on MapLayerVisibilityChangedEvent when layer is made visible
          lyr.setStyle(_this4.getCurrentOlStyle(layer));
        }
        _this4.getMapModule().addLayer(lyr, !keepLayerOnTop);
      });
    }

    /**
     * @method refreshLayersOfType
     * @param {String} layerType
     */
  }, {
    key: "refreshLayersOfType",
    value: function refreshLayersOfType(layerType) {
      var _this5 = this;
      if (!layerType) {
        return;
      }
      this.getSandbox().getMap().getLayers().filter(function (layer) {
        return layer.getLayerType() === layerType;
      }).forEach(function (layer) {
        var handler = _this5._getLayerHandler(layer);
        if (handler) {
          handler.refreshLayer(layer);
        }
      });
    }

    /* ---- Impl specific functions ---- */

    /**
     * @method findLayerByOLLayer
     * @param {ol/layer/Layer} olLayer OpenLayers layer impl
     * @return {Oskari.mapframework.bundle.mapwfs2.domain.WFSLayer}
     */
  }, {
    key: "findLayerByOLLayer",
    value: function findLayerByOLLayer(olLayer) {
      var _this6 = this;
      var layerId = Object.keys(this._layerImplRefs).find(function (layerId) {
        return olLayer === _this6._layerImplRefs[layerId];
      });
      return this.getSandbox().getMap().getSelectedLayer(layerId);
    }

    /**
     * @method getAllLayerIds
     * @return {String[]} All layer ids handled by plugin and selected on map
     */
  }, {
    key: "getAllLayerIds",
    value: function getAllLayerIds() {
      return Object.keys(this._layerImplRefs);
    }

    /**
     * Helper to access the correct layer handler impl for a layer.
     * @param {AbstractLayer | string | number} layer layer object or id
     */
  }, {
    key: "_getLayerHandler",
    value: function _getLayerHandler(layer) {
      if (!layer) {
        return;
      }
      var id = _typeof(layer) === 'object' ? layer.getId() : layer;
      return this.layerHandlersByLayerId[id];
    }

    /**
     * @method getCurrentOlStyle
     * Returns OL style corresponding to layer currently selected style
     * @param {Oskari.mapframework.bundle.mapwfs2.domain.WFSLayer} layer
     * @return {ol/style/Style | StyleLike}
     */
  }, {
    key: "getCurrentOlStyle",
    value: function getCurrentOlStyle(layer) {
      return styleGenerator(this.mapModule, layer);
    }

    /**
     * @method updateLayerStyle
     * @param {Oskari.mapframework.bundle.mapwfs2.domain.WFSLayer} layer
     */
  }, {
    key: "updateLayerStyle",
    value: function updateLayerStyle(layer) {
      var _this7 = this;
      if (!this.isLayerSupported(layer)) {
        return;
      }
      var olLayers = this.getOLMapLayers(layer);
      if (!olLayers || olLayers.length === 0) {
        return;
      }
      var style = this.getCurrentOlStyle(layer);
      olLayers.forEach(function (lyr) {
        if (lyr.get(LAYER_HOVER)) {
          // don't add style for hover layer
          return;
        }
        lyr.setStyle(style);
        if (_this7.renderMode === RENDER_MODE_VECTOR && _this7.getMapModule().getSupports3D()) {
          // Trigger features changed to synchronize 3D view
          lyr.getSource().getFeatures().forEach(function (ftr) {
            return ftr.changed();
          });
        }
      });
    }

    /**
     * @method updateLayerProperties
     * Requests and sets feature properties
     * @param {Oskari.mapframework.bundle.mapwfs2.domain.WFSLayer} layer wfs layer
     * @param {Array} fields
     */
  }, {
    key: "updateLayerProperties",
    value: function updateLayerProperties(layer) {
      var _this8 = this;
      if (!layer) {
        return;
      }
      var onSuccess = function onSuccess(response) {
        var lang = Oskari.getLang();
        var _response$types = response.types,
          types = _response$types === void 0 ? {} : _response$types,
          _response$locale = response.locale,
          locale = _response$locale === void 0 ? {} : _response$locale,
          selection = response.selection;
        if (Array.isArray(selection)) {
          layer.setPropertyFilter(selection);
        } else if (selection) {
          var selectionArray = selection[lang] || selection.default || [];
          layer.setPropertySelection(selectionArray);
        }
        var labels = locale[lang] || locale.default || {};
        layer.setPropertyLabels(labels);
        layer.setPropertyTypes(types);
        // TODO: event should have only locale object not separate arrays
        _this8.notify('WFSPropertiesEvent', layer, layer.getLocales(), layer.getFields());
      };
      jQuery.ajax({
        type: 'GET',
        dataType: 'json',
        data: {
          layer_id: layer.getId()
        },
        url: Oskari.urls.getRoute('GetWFSLayerFields'),
        success: onSuccess,
        error: function error() {
          _this8._log.warn('Error getting fields for wfs layer ' + layer.getId());
        }
      });
    }
  }, {
    key: "notify",
    value: function notify(eventName) {
      var builder = Oskari.eventBuilder(eventName);
      if (!builder) {
        return;
      }
      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }
      Oskari.getSandbox().notifyAll(builder.apply(null, args));
    }

    /**
     * Called when layer details are updated (for example by the admin functionality)
     * @param {Oskari.mapframework.domain.AbstractLayer} layer new layer details
     */
  }, {
    key: "_updateLayer",
    value: function _updateLayer(layer) {
      if (!this.isLayerSupported(layer)) {
        return;
      }
      var handler = this._getLayerHandler(layer);
      if (!handler) {
        return;
      }
      var layersImpls = this.getOLMapLayers(layer.getId()) || [];
      layersImpls.forEach(function (olLayer) {
        handler.applyZoomBounds(layer, olLayer);
      });
    }
  }]);
}(AbstractVectorLayerPlugin);
;
Oskari.clazz.defineES('Oskari.wfsvector.WfsVectorLayerPlugin', WfsVectorLayerPlugin, {
  /**
   * @property {String[]} protocol array of superclasses as {String}
   * @static
   */
  protocol: ['Oskari.mapframework.module.Module', 'Oskari.mapframework.ui.module.common.mapmodule.Plugin']
});